import { theme as defaultTheme, Button } from "@mindlercare/ui-web";

import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import { withTranslation, type WithTranslation } from "react-i18next";
import { styled } from "styled-components";
import { logger } from "core/logger";
import { ComponentBaseProps } from "../componentProps";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => defaultTheme.COLORS.WHITE};
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 400px;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  min-width: 200px;
  max-width: 400px;
`;
const InnerContainer = styled.div`
  color: ${({ theme }) => defaultTheme.COLORS.BLACK};
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.STANDARD};
  padding: 32px;
`;
const ButtonWrapper = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const ErrorFallback = ({
  resetErrorBoundary,
  t,
}: WithTranslation & FallbackProps) => {
  return (
    <Container>
      <Wrapper>
        <Title>
          <img src={"/img/mindler_logo.svg"} />
        </Title>
        <InnerContainer>
          {t("UNCAUGHT_FAILURE")}
          <ButtonWrapper>
            <Button variant="primary" onClick={() => resetErrorBoundary()}>
              {t("RELOAD_PAGE")}
            </Button>
          </ButtonWrapper>
        </InnerContainer>
      </Wrapper>
    </Container>
  );
};

const WrappedErrorFallback = withTranslation()(ErrorFallback);

const errorHandler = (error: Error, info: { componentStack: string }) => {
  // Don't log yet in production until we know what kind of errors we're catching here
  if (!import.meta.env.PROD) {
    logger.error("Error caught by ErrorBoundary", {
      error,
      stackTrace: info.componentStack,
    });
  }
};

export const MainErrorBoundary: React.FC<ComponentBaseProps> = ({
  children,
}) => {
  const handleReset = () => {
    // Redirect to frontpage
    window.location.href = "/";
  };

  return (
    <ErrorBoundary
      FallbackComponent={WrappedErrorFallback}
      onError={errorHandler}
      onReset={handleReset}
    >
      {children}
    </ErrorBoundary>
  );
};
